/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    makeAsyncReducer,
    asyncDefaults,
    mergeReducers,
} from 'ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';
import { ReservationDefaults } from '../props/reservation';

const fetchReservation = makeAsyncReducer(types.FETCH_RESERVATION);
const createReservation = makeAsyncReducer(types.CREATE_RESERVATION);
const updateReservation = makeAsyncReducer(types.UPDATE_RESERVATION);

function updateCurrentReservation(state, action) {
    switch (action.type) {
        case types.UPDATE_CURRENT_RESERVATION:
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.payload,
                },
            };
        default:
            return state;
    }
}

const reservation = mergeReducers(
    asyncDefaults(ReservationDefaults),
    types.PREFIX,
    fetchReservation,
    createReservation,
    updateReservation,
    updateCurrentReservation
);

export default reservation;

// Selectors
export const selectors = {
    getReservation: (state) => state.pass.reservation.data,
};
